import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

@Injectable()
export class AutoRedemptionFeatureGuard implements CanActivate {
  constructor(
    private router: Router,
    private featureFlagService: FeatureFlagService,
  ) {}

  canActivate(): boolean {
    if (!this.featureFlagService.isAutoRedemptionEnabled) {
      this.router.navigate(['/orders']);
      return false;
    }

    return true;
  }
}
